<template>
	<div class="christmas-offer-ribbon">
		<img src="@/assets/christmas-ribbon.svg" />
		<div class="christmas-offer-ribbon__text"><slot></slot></div>
	</div>
</template>

<style lang="scss" scoped>
.christmas-offer-ribbon {
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	transform: rotate(-1.34deg);

	&__text {
		position: absolute;
		width: 100%;
		font-weight: 700;
		letter-spacing: -0.02em;
		text-transform: uppercase;
		color: #ffffff;
		text-align: center;
		white-space: nowrap;
	}
}
[lang='es'] {
	.christmas-offer-ribbon {
		&__text {
			font-size: 0.76rem;
		}
	}
}

[lang='ru'] {
	.christmas-offer-ribbon {
		&__text {
			font-size: 0.9rem;
		}
	}
}
</style>
